import React, { useState } from 'react';
import { Box, Typography, Card, CardContent, Grid, Button, List, ListItem, ListItemText, Divider, Chip } from '@mui/material';

const mockCharges = [
  {
    id: 1,
    name: 'Membership Fee',
    dueDate: '2024-06-10',
    amountDue: 50,
    amountPaid: 50,
    amountWaived: 0,
    amountOutstanding: 0,
    status: 'Paid',
  },
  {
    id: 2,
    name: 'Loan Processing',
    dueDate: '2024-06-15',
    amountDue: 100,
    amountPaid: 0,
    amountWaived: 0,
    amountOutstanding: 100,
    status: 'Outstanding',
  },
  {
    id: 3,
    name: 'Late Payment',
    dueDate: '2024-06-20',
    amountDue: 25,
    amountPaid: 0,
    amountWaived: 25,
    amountOutstanding: 0,
    status: 'Waived',
  },
];

const Charges: React.FC = () => {
  const [charges, setCharges] = useState(mockCharges);
  const [loading, setLoading] = useState(false);

  const handleRefresh = () => {
    setLoading(true);
    setTimeout(() => {
      setCharges(mockCharges); // In real app, fetch from backend
      setLoading(false);
    }, 1000);
  };

  const handleChargeClick = (id: number) => {
    // TODO: navigate to charge details page
    alert('Navigate to charge details for ID: ' + id);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 2 }}>
        <Typography variant="h4" sx={{ flexGrow: 1 }}>Charges</Typography>
        <Button variant="outlined" onClick={handleRefresh} disabled={loading}>
          {loading ? 'Refreshing...' : 'Refresh'}
        </Button>
      </Box>
      <Card>
        <CardContent>
          <List>
            {charges.map(charge => (
              <React.Fragment key={charge.id}>
                <ListItem button onClick={() => handleChargeClick(charge.id)} alignItems="flex-start">
                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>{charge.name}</span>
                        <Chip label={charge.status} color={charge.status === 'Paid' ? 'success' : charge.status === 'Waived' ? 'warning' : 'primary'} size="small" />
                      </Box>
                    }
                    secondary={
                      <Box>
                        <Grid container spacing={1}>
                          <Grid item xs={6} sm={4}>
                            <strong>Due Date:</strong> {charge.dueDate}
                          </Grid>
                          <Grid item xs={6} sm={4}>
                            <strong>Amount Due:</strong> ${charge.amountDue}
                          </Grid>
                          <Grid item xs={6} sm={4}>
                            <strong>Paid:</strong> ${charge.amountPaid}
                          </Grid>
                          <Grid item xs={6} sm={4}>
                            <strong>Waived:</strong> ${charge.amountWaived}
                          </Grid>
                          <Grid item xs={6} sm={4}>
                            <strong>Outstanding:</strong> ${charge.amountOutstanding}
                          </Grid>
                        </Grid>
                      </Box>
                    }
                  />
                </ListItem>
                <Divider component="li" />
              </React.Fragment>
            ))}
            {charges.length === 0 && (
              <ListItem>
                <ListItemText primary="No charges found." />
              </ListItem>
            )}
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Charges; 